
import { Vue, Component } from "vue-property-decorator";
import useGlobalSetting from "@/composables/use-global-setting";
import OrganizationEditor from "@/components/OrganizationEditor.vue";
import { get } from "@/store/pathify-helper";
import { ref } from "@vue/composition-api";
import { ENGINE_OPTIONS } from "@/datas/common.data";
@Component({ components: { OrganizationEditor } })
export default class GlobalSetting extends Vue {
  setup(props: any, context: any) {
    const engineOptions = ref(ENGINE_OPTIONS);
    const user = get(context, "auth/user");
    const {
      globalEngine,
      fetchGlobalUrgentConfig,
      updateGlobalUrgentConfig,
      onChangeGlobalEngine,
      isUrgentChanged
    } = useGlobalSetting();
    return {
      user,

      // useGlobalSetting
      globalEngine,
      fetchGlobalUrgentConfig,
      updateGlobalUrgentConfig,
      onChangeGlobalEngine,
      isUrgentChanged,
      engineOptions
    };
  }
}
